import FilterChip from 'LuxKit/Chips/FilterChip'
import SolidCheckCircleIcon from 'LuxKit/Icons/solid/SolidCheckCircleIcon'
import Group from 'components/utils/Group'
import React from 'react'

const DIETARY_REQUIREMENTS = [
  {
    dietaryRequirement: 'Vegan',
  },
  {
    dietaryRequirement: 'Vegetarian',
  },
  {
    dietaryRequirement: 'Gluten-free',
  },
  {
    dietaryRequirement: 'Halal',
  },
]

interface Props {
  dietaryRequirements: Array<{
    dietaryRequirement: string
    selected: boolean
  }>
  onDietaryRequirementSelect: (dietaryRequirement: string) => void
}

function DietaryRequirements({ dietaryRequirements, onDietaryRequirementSelect }: Props) {
  return (
    <Group direction="horizontal" gap={12} wrap="wrap">
      {DIETARY_REQUIREMENTS.map((requirement) => {
        const isSelected = dietaryRequirements.find(
          d => d.dietaryRequirement === requirement.dietaryRequirement,
        )?.selected || false

        return (
          <FilterChip
            key={requirement.dietaryRequirement}
            selected={isSelected}
            size="large"
            onClick={() => onDietaryRequirementSelect(requirement.dietaryRequirement)}
            endIcon={isSelected ? <SolidCheckCircleIcon /> : undefined}
          >
            {requirement.dietaryRequirement}
          </FilterChip>
        )
      })}
    </Group>
  )
}

export default DietaryRequirements
